import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEmpty, noop, map, get } from "lodash";
import { Link } from "react-router-dom";
import { normalizeAmount, formatData } from "../../utils/transformer.util";
import {
  Button,
  Select,
  Textarea,
  SearchSelect,
} from "../../components/base/index";
import { JADWAL_MATPEL_LIST_TABLE_FIELDS } from "../../constants/Student/student.constant";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import ReactToPrint from "react-to-print";
import ReactExport from "react-export-excel";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const { ExcelFile } = ReactExport;
const { ExcelSheet, ExcelColumn } = ExcelFile;
const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

export default class RekapJadwal extends Component {
  constructor(props) {
    super(props);
    this._onSearchContent = this._onSearchContent.bind(this);
    this._onClickAdd = this._onClickAdd.bind(this);
    this._onClickCetak = this._onClickCetak.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this._renderButtons = this._renderButtons.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    // this._getPrmLevels = this._getPrmLevels.bind(this);
    this._onClickDetails = this._onClickDetails.bind(this);
    this._onClickBack = this._onClickBack.bind(this);
    this._getPeriodsOptions = this._getPeriodsOptions.bind(this);
    this._onClickPosting = this._onClickPosting.bind(this);
    this._ttlJP = this._ttlJP.bind(this);
    this._getNotesUnpostingSch = this._getNotesUnpostingSch.bind(this);
    this._getSchoolUnitsOptions = this._getSchoolUnitsOptions.bind(this);
    this._onClickSet = this._onClickSet.bind(this);
    this._getPrmLevelRecap = this._getPrmLevelRecap.bind(this);
    this._getSemesterOptions = this._getSemesterOptions.bind(this);

    const { user } = this.props;
    const { school_unit } = user;
    const { levels_id } = school_unit;

    this.state = {
      page: 1,
      isTable: true,
      selected: {},
      content: initialContent,
      unchecked: {},
      filters: {},
      list: [],
      form: {
        value: {
          levels_id,
          classrooms: [],
          levels: [],
          classrooms_id: "",
          listjadwal: [],
          listDetails: [],
          user_id: user.id,
        },
        error: {
          classrooms: "",
          levels: "",
        },
      },
      param: {},
      filtered: false,
    };
  }

  componentDidMount() {
    const { user, location } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { organizations_id, user_group } = user;
    const { content, form, filters } = this.state;
    // console.log(data)
    //   if (isEdit && data) {
    //   this._onSearchContentDetails(data);
    // }
    let savedForm =
      JSON.parse(window.localStorage.getItem("RekapJadwalForm")) || "";
    let savedFilters =
      JSON.parse(window.localStorage.getItem("RekapJadwalFilters")) || filters;
    if (savedForm != "" && user.id != savedForm.value.user_id) {
      savedForm = "";
      savedFilters = filters;
    }
    this._initializeData(savedFilters);
    if (savedForm != "") {
      this.setState((prevState) => ({
        ...prevState,
        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            units_id: savedFilters.units_id ? savedFilters.units_id : "",
          },
        },
        filters: {
          ...prevState.filters,
          units_id: savedFilters.units_id ? savedFilters.units_id : "",
          // entrance_year : savedFilters.entrance_year,
        },
      }));
      if (user_group.name === "pusat" || user_group.name === "pengurus") {
        console.log(savedFilters);
        console.log(
          savedFilters.units_id
            ? savedFilters.units_id.attributes.levels_id
            : "",
        );
        this._getPeriodsOptions({
          units_id: savedFilters.units_id ? savedFilters.units_id : "",
        });
        this._getPrmLevelRecap({
          levels_id: savedFilters.units_id
            ? savedFilters.units_id.attributes.levels_id
            : "",
        });
      }
    }
    // this._getPrmLevels({ filters: {units_id: [school_unit.id], organizations_id: organizations_id } });
  }

  async _initializeData(savedFilters = {}) {
    const { user } = this.props;
    const { content } = this.state;
    const { school_unit, user_group } = user;

    if (user_group.name !== "pusat") {
      await this._getPeriodsOptions({ units_id: school_unit.id });
      this._getPrmLevelRecap({ levels_id: school_unit.levels_id });
    }
    await this._getSchoolUnitsOptions();
    // await this._getPrmLevelRecap();

    if (user_group.name == "pusat" || user_group.name === "pengurus") {
      this.setState(
        (prevState) => ({
          filters: {
            ...prevState.filters,
            period: savedFilters.period,
          },
        }),
        // () => {
        //   // commonActions.setLoading({ show: true });
        //   this._onSearchContent();
        // },
      );
    } else {
      this.setState(
        (prevState) => ({
          filters: {
            ...prevState.filters,
          },
        }),
        () => {
          // commonActions.setLoading({ show: true });
          this._onSearchContent();
        },
      );
    }
  }

  async _getSemesterOptions(filters = {}) {
    const { getSemesterOptions } = this.props;

    const res = await getSemesterOptions(filters);

    let semesters = res;
    let semesterId = "";

    // Kalau tahun ajaran TIDAK punya semester
    if (!res || res.length === 0) {
      semesters = [
        {
          value: "all",
          label: "Semua Semester",
        },
      ];

      // PENTING: otomatis pilih "Semua Semester"
      semesterId = "all";
    } else {
      // Kalau punya semester, cari semester berdasarkan tanggal sekarang
      const now = new Date();

      const currentSemester = res.find((item) => {
        const startDate = new Date(item.start_date);
        const endDate = new Date(item.end_date);

        return now >= startDate && now <= endDate;
      });

      // otomatis pilih semester berjalan
      semesterId = currentSemester ? currentSemester.value : "";
    }

    console.log("SEMESTER OPTIONS:", semesters);
    console.log("SEMESTER TERPILIH:", semesterId);

    this.setState((prevState) => ({
      ...prevState,

      param: {
        ...prevState.param,
        semesters: semesters,
      },

      filters: {
        ...prevState.filters,
        semester_id: semesterId,
      },

      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          semester_id: semesterId,
        },
      },
    }));
  }

  exportToExcelAll = () => {
    const { form } = this.state;
    const rows =
      form.value.listjadwal && form.value.listjadwal.rows
        ? form.value.listjadwal.rows
        : [];

    let data = [];

    rows.forEach((list) => {
      // 🔥 JUDUL HARI
      data.push([list.day_name]);
      data.push([]);

      const levels = get(list, "details[0].levels", []);

      // ===== HEADER 1 =====
      let header1 = ["JP", "Waktu"];
      levels.forEach((lvl) => {
        lvl.data_class.forEach(() => {
          header1.push("Kelas " + lvl.classes_name);
        });
      });

      // ===== HEADER 2 =====
      let header2 = ["", ""];
      levels.forEach((lvl) => {
        lvl.data_class.forEach((cls) => {
          header2.push(cls.classrooms_name);
        });
      });

      data.push(header1);
      data.push(header2);

      // ===== BODY =====
      list.details.forEach((detail) => {
        let row = [detail.jp, detail.hour];

        levels.forEach((headerLvl) => {
          headerLvl.data_class.forEach((headerCls) => {
            const findLevel = detail.levels.find(
              (lvl) => lvl.classes_id === headerLvl.classes_id,
            );

            const findClass =
              findLevel &&
              findLevel.data_class.find(
                (c) => c.classrooms_id === headerCls.classrooms_id,
              );

            row.push(findClass ? findClass.teacher_code : "-");
          });
        });

        data.push(row);
      });

      // 🔥 JARAK ANTAR HARI
      data.push([]);
      data.push([]);
    });

    // ===== BUAT 1 SHEET =====
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Jadwal");

    const wbout = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    saveAs(new Blob([wbout]), "jadwal-sekolah.xlsx");
  };

  async _getSchoolUnitsOptions(filters = {}) {
    const { getSchoolUnitsOptions } = this.props;
    const { form } = this.state;
    const { units_id } = form.value;
    const res = await getSchoolUnitsOptions(filters);
    const selectedUnits = res.find((item) => item.value == units_id);

    // console.log(units_id)
    this.setState((prevState) => ({
      ...prevState,
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          levels_units: selectedUnits ? selectedUnits.attributes.levels_id : "",
        },
      },
      param: {
        ...prevState.param,
        units: res,
      },
    }));
  }

  async _getNotesUnpostingSch(payload = {}) {
    const { filters, param, form } = this.state;
    const { getNotesUnpostingSch, user, getPeriodsOptions } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const { units_id, levels_id } = school_unit;
    console.log(form.value);
    const units =
      user_group.name == "pusat" ||
      user_group.name == "perwakilan" ||
      user_group.name === "pengurus"
        ? filters.units_id
          ? filters.units_id
          : ""
        : school_unit.id;
    console.log(units);

    const res = await getNotesUnpostingSch({
      ...payload,
      organizations_id,
      units_id: units,
      period_id: filters.period,
    });
    // filters.organizations_id = organizations_id;
    // filters.units_id = units_id;

    this.setState((prevState) => ({
      ...prevState,
      notes: res,
    }));
  }

  async _ttlJP(payload = {}) {
    const { filters, param, form } = this.state;
    const { handleGetJp, user, getPeriodsOptions } = this.props;
    const { organizations_id, school_unit, user_group } = user;
    const { units_id, levels_id } = school_unit;
    console.log(form.value);
    const units =
      user_group.name == "pusat" ||
      user_group.name == "perwakilan" ||
      user_group.name === "pengurus"
        ? filters.units_id
          ? filters.units_id
          : ""
        : school_unit.id;
    console.log(units);

    const res = await handleGetJp({
      ...payload,
      levels_id: levels_id,
    });
    // filters.organizations_id = organizations_id;
    // filters.units_id = units_id;

    this.setState((prevState) => ({
      ...prevState,
      ttl_jp: res,
    }));
  }

  async _getPrmLevels(filters = {}) {
    const { getPrmLevels, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { units_id, levels_id } = school_unit;
    const res = await getPrmLevels(filters);
    filters.organizations_id = organizations_id;

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        levels: res,
      },
    }));
  }

  async _getPrmLevelRecap(filters = {}) {
    const { getPrmLevelRecap, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { units_id, levels_id } = school_unit;
    const res = await getPrmLevelRecap(filters);
    filters.organizations_id = organizations_id;
    // levels_id = school_unit.levels_id;

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        prm_level_recap: res,
      },
    }));
  }

  _onClickAdd() {
    const { history } = this.props;
    const { ttl_jp } = this.state;
    history.push("/dashboard/pengaturan/tambah-jadwal-matpel", {
      isEdit: true,
      ttl_jp: ttl_jp,
    });
  }

  onClickEdit(val) {
    const { history } = this.props;
    const { ttl_jp } = this.state;
    history.push("/dashboard/pengaturan/tambah-jadwal-matpel", {
      data: val,
      ttl_jp: ttl_jp,
      isEdit: true,
    });
  }

  async _getPrmLevels(filters = {}) {
    const { getPrmLevels, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { units_id, levels_id } = school_unit;
    const res = await getPrmLevels(filters);
    filters.organizations_id = organizations_id;

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        levels: res,
      },
    }));
  }

  _onClickCetak() {
    const { history } = this.props;
    history.push(
      "/dashboard/kurikulum/mata-pelajaran/cetak/jadwal-mata-pelajaran",
    );
  }

  async _getPeriodsOptions(filters = {}) {
    const { getPeriodsOptions } = this.props;

    const res = await getPeriodsOptions(filters);

    const now = new Date();
    const month = now.getMonth() + 1;
    const year = now.getFullYear();

    // Tentukan tahun ajaran berjalan
    const currentAcademicYear =
      month >= 7 ? `${year}-${year + 1}` : `${year - 1}-${year}`;

    // Cari period yang sedang berjalan
    const currentPeriod = res.find(
      (item) => item.label === currentAcademicYear,
    );

    if (currentPeriod) {
      const periods_id = currentPeriod.value;

      // SET PERIOD
      this.setState((prevState) => ({
        ...prevState,

        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            periods_id,
          },
        },

        filters: {
          ...prevState.filters,
          period: periods_id,
        },

        param: {
          ...prevState.param,
          periods: res,
        },
      }));

      // CUMA SEKALI
      await this._getSemesterOptions({
        periods_id,
      });
    } else {
      this.setState((prevState) => ({
        ...prevState,

        param: {
          ...prevState.param,
          periods: res,
          semesters: [],
        },
      }));
    }
  }

  async _onClickDetails(val, idx) {
    const { history } = this.props;
    history.push("/dashboard/pengaturan/data-jadwal-matpel-details", {
      data: val,
      // isEdit: true,
    });
  }

  _onClickBack() {
    window.scrollTo(0, 0);
    this.setState((prevState) => ({
      page: prevState.page - 1,
    }));
  }

  _onFormChange(event) {
    const { name, value, dataset, checked, type } = event.target;
    const {
      inputType = "text",
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;
    const { user } = this.props;
    const { organizations_id } = user;
    this.setState(
      (prevState) => {
        let newList = [];
        let newListError = [];
        let formattedValue = value;

        if (inputType === "number") {
          formattedValue = normalizeAmount(value);
        }
        if (inputArray) {
          if (type === "checkbox") {
            formattedValue = checked;
          }
          newList = prevState.form.value[fieldName];
          newListError = prevState.form.error[fieldName];
          newList[arrayPosition][name] = formattedValue;
          if (name === "code_of_account") {
            newList[arrayPosition].isCredit = value.type;
          }
          if (!isEmpty(newListError[arrayPosition])) {
            newListError[arrayPosition][name] = "";
          }
        }
        return {
          form: {
            value: {
              ...prevState.form.value,
              ...(inputArray
                ? { [fieldName]: newList }
                : { [name]: formattedValue }),
            },
            error: {
              ...prevState.form.error,
              ...(inputArray ? { [fieldName]: newListError } : { [name]: "" }),
            },
          },
        };
      },
      () => {
        if (name === "levels_id") {
          this._getParamOptionsAcademics("classrooms", {
            levels_id: value,
            organizations_id,
          });
        }
      },
    );
  }

  async _getParamOptionsAcademics(type, filters = {}) {
    const { getParamOptionsAcademics, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { levels_id } = school_unit;

    if (type === "classrooms" || type === "classrooms") {
      filters.organizations_id = organizations_id;
      filters.units_id = school_unit.id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptionsAcademics(filters, type);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }

  async _onSearchContent(params = {}) {
    const { filters, form } = this.state;
    const { students_id = "", period, units_id, levels_recap, semester_id } = filters;
    const { periods_id } = form.value;

    console.log(filters);
    this.setState(
      {
        content: initialContent,
      },
      async () => {
        try {
          const { handleListRekapJadwal, user } = this.props;
          const { organizations_id, school_unit, user_group } = user;
          const { units_id } = school_unit;
          console.log(levels_recap);
          const result = await handleListRekapJadwal({
            ...params,
            organizations_id,
            levels_recap: levels_recap,
            units_id:
              user_group.name == "pusat" || user_group.name === "pengurus"
                ? filters.units_id.value
                : school_unit.id,
            periods_id: period,
            semester_id: semester_id,
            filters,
          });
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listjadwal: result,
              },
            },
          }));
        } catch (err) {
          // if (this.isMount) {
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listjadwal: [],
              },
            },
          }));
        }
        // }
      },
    );
  }

  async _onSearchContentDetails(params = {}) {
    const { filters, form } = this.state;
    const { value } = form;
    const { period } = filters;
    const { location, getLevels, getclassrooms, user } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { user_group } = user;
    this.setState(
      {
        content: initialContent,
      },
      async () => {
        try {
          const { handlelistReportSchedule, user } = this.props;
          const { organizations_id, school_unit } = user;
          const { units_id } = school_unit;

          let result = [];
          if (filters.levels_recap) {
            result = await handlelistReportSchedule({
              ...params,
              organizations_id,
              units_id:
                user_group.name == "pusat" || user_group.name === "pengurus"
                  ? filters.units_id.value
                  : school_unit.id,
              // classrooms_id: classrooms_id,
              periods_id: period,

              filters,
            });
          }
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listDetails: result,
              },
            },
          }));
        } catch (err) {
          // if (this.isMount) {
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listDetails: [],
              },
            },
          }));
        }
        // }
      },
    );
  }

  async onClickDelete(id) {
    const { handleDeleteScheduleSubject } = this.props;
    const res = await handleDeleteScheduleSubject(id);
    if (res) {
      this._onSearchContent();
    }
  }

  _renderButtons(data) {
    const { user } = this.props;
    const { user_group } = user;
    const button = {};

    return (
      <td>
        <div className="table__actions">
          {user_group.name == "pusat" || user_group.name === "pengurus" ? (
            <Button
              onClick={() => this._onClickDetails(data)}
              title="Lihat Detail"
            />
          ) : (
            <>
              <Button
                onClick={() => this._onClickDetails(data)}
                title="Lihat Detail"
              />
            </>
          )}
        </div>
      </td>
    );
  }

  onSubmit(e) {
    e.preventDefault();
    // const { form} = this.state;
    const { form } = this.state;
    const { handleAddBudget, history, user } = this.props;
    const { workingUnit, prm_school_units_id } = user;

    let unit_id = prm_school_units_id;

    if (unit_id === null && workingUnit && workingUnit.id) {
      unit_id = workingUnit.id;
    }
    handleAddBudget(form.value, history.goBack, unit_id);
    // handleAddBudget(form.value, plafon, history.goBack, unit_id);
    // handleAddBudget(form.value, history.goBack, unit_id);
  }

  async _onClickPosting() {
    const { filters, form } = this.state;
    const { value } = form;
    const { period } = filters;
    const { handleGenerateSchedule, history, user } = this.props;
    const { school_unit, user_group, organizations_id } = user;
    const res = await handleGenerateSchedule({
      organizations_id: organizations_id,
      units_id: school_unit.id,
      periods_id: period,
    });
    if (res) {
      history.push("/dashboard/pengaturan/data-jadwal-matpel");

      // this._onSearchContent();
      history.go(0);
    }
  }

  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    const { user } = this.props;
    const { organizations_id } = user;
    this.setState(
      (prevState) => ({
        ...prevState,
        filters: {
          ...prevState.filters,
          [name]: value,
        },
      }),
      () => {
        window.localStorage.setItem(
          "RekapJadwalForm",
          JSON.stringify(this.state.form),
        );
        window.localStorage.setItem(
          "RekapJadwalFilters",
          JSON.stringify(this.state.filters),
        );

        if (name === "units_id") {
          const param = this.state.param.units;
          console.log(value.value);
          const levels_units = param.find((i) => i.value == value.value)
            ? param.find((i) => i.value == value.value).attributes.levels_id
            : "";

          console.log(levels_units);
          this.setState((prevState) => ({
            ...prevState,
            isTable: true,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                classrooms_id: "",
                levels_recap: "",
                units_id: value,
              },
            },
            filters: {
              ...prevState.filters,
              period: "",
              levels_recap: "",
            },
          }));
          this._getPeriodsOptions({ units_id: value.value });
          this._getPrmLevelRecap({ levels_id: levels_units });
        }

        if (name === "levels_id") {
          this._getParamOptionsAcademics("classrooms", {
            filters: { levels_id: value, organizations_id },
          });
        }
          if (name === "period") {
  this.setState(
    (prevState) => ({
      ...prevState,
      filters: {
        ...prevState.filters,
        period: value,
        semester_id: "",
      },
      form: {
        ...prevState.form,
        value: {
          ...prevState.form.value,
          periods_id: value,
          semester_id: "",
        },
      },
    }),
    () => {
      this._getSemesterOptions({
        periods_id: value,
      });
    },
  );
}
        this._onSearchContent();
        this._onSearchContentDetails();
      },
    );
  }

  _onClickSet() {
    this.setState(
      (prevState) => ({
        ...prevState,
        isTable: false,
        filters: {
          ...prevState.filters,
        },
      }),
      () => {
        this._onSearchContent();
      },
    );
  }

  render() {
    const { form, content, param, filters, page, ttl_jp, notes, isTable } =
      this.state;
    const { value } = form;
    const { listjadwal, listDetails } = form.value;
    const rows = (listjadwal && listjadwal.rows) || [];
    const years = [];
    const thisyear = new Date().getFullYear();

    // console.log(rows)
    const { classrooms_id = "", period = "" } = filters;
    const { handleGetKelas, handleDeleteKelas, coa, classrooms, user } =
      this.props;
    const { user_group } = user;
    const componentRef = React.createRef();
    const printTest = `
@media print {
  @page {
    size: A4 landscape;
    margin: 10mm;
  }

  body {
    -webkit-print-color-adjust: exact;
    font-family: Arial, sans-serif;
  }

  #printable {
    width: 100%;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  thead {
    display: table-header-group;
  }

  th, td {
    border: 1px solid #000;
    padding: 4px;
    font-size: 10px;
    text-align: center;
    white-space: nowrap;
  }

  tr {
    page-break-inside: avoid;
  }

  h1 {
    font-size: 14px;
    margin: 8px 0;
  }
}
`;
    const period_label_all = years.find((i) => i.value == period)
      ? years.find((i) => i.value == period).label
      : "";
    return (
      <div className="add-budget">
        {user_group.name === "pusat" || user_group.name === "pengurus" ? (
          <div className="absensi-rekap__custom-form-row">
            <div className="absensi-rekap__custom-form-row__field">
              <SearchSelect
                noMargin
                async={false}
                name="units_id"
                list={param.units}
                inputArray
                onClick={this._onChangeFilter}
                placeholder="Pilih Unit"
                value={form.value.units_id}
                rightIcon="icon-search"
                label="Pilih Unit"
              />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="absensi-rekap__custom-form-row">
          <div className="absensi-rekap__custom-form-row__field">
            <Select
              name="period"
              label="Tahun Ajaran"
              placeholder="Pilihan"
              onChange={this._onChangeFilter}
              data={param.periods}
              value={filters.period}
              disabled={user_group.name == "pusat" ? false : true}
            />
            <div className="manage-registration__custom-form-row-datadiri">
              <Select
                name="semester_id"
                label="Semester"
                placeholder="Pilihan"
                onChange={this._onChangeFilter}
                data={param.semesters}
                value={filters.semester_id}
                // disabled
              />
            </div>
          </div>
          <div className="absensi-rekap__custom-form-column__field">
            <Select
              type="text"
              name="levels_recap"
              label="Pilih Tingkat"
              placeholder="Pilih Tingkat"
              data={param.prm_level_recap}
              onChange={this._onChangeFilter}
              value={filters.levels_recap}
              // disabled
            />
          </div>
        </div>
        <div className="beginning-balance__button-wrapper">
          {/* <ReactToPrint
                    pageStyle={printTest}
                    onBeforeGetContent={() =>
                      new Promise((resolve) => {
                        setTimeout(() => {
                          this.setState({ isPrint: false }, resolve);
                        }, 500);
                      })
                    }
                    onAfterPrint={() => this.setState({ isPrint: true })}
                    trigger={() => <Button title="Cetak" />}
                    content={() => componentRef.current}
                  /> */}
          {/* <Button
                      title="Ekspor Excel"
                      onClick={this._onClickExcel}
                    /> */}
          &nbsp;
          <div style={{ marginLeft: "0rem" }} className="student-list__button">
            <Button title="Unduh ke Excel" onClick={this.exportToExcelAll} />
          </div>
        </div>
        {listjadwal ? (
          <div
            style={{
              backgroundColor: "#FEF3C7", // kuning muda
              border: "1px solid #FCD34D",
              borderRadius: "12px",
              padding: "16px",
              fontSize: "14px",
              color: "#4B5563",
              marginBottom: "20px",
              marginTop: "20px",
            }}
          >
            Jika masih terdapat kolom jadwal yang kosong. Mohon segera
            dilengkapi melalui menu Jadwal Mata Pelajaran.
          </div>
        ) : (
          ""
        )}
        <div
          className="student-list__button2"
          ref={componentRef}
          style={{ width: "100%" }}
        >
          <div className="fund-request__content">
            {map(rows, (list, idx) => {
              var levels = get(list, "details[0].levels", []);
              const headerLevels = get(list, "details[0].levels", []);

              return (
                <div
                  key={`budget_row_${idx}`}
                  // style={{
                  //   pageBreakAfter: "always",
                  //   marginBottom: "20px",
                  // }}
                  // style={{ overflowX: "auto" }}
                >
                  <h1>{list.day_name}</h1>

                  <table
                    className="table"
                    id="printable"
                    style={{
                      minWidth: "2000px",
                      tableLayout: "fixed", // 🔥 ini bikin kolom sama rata
                    }}
                  >
                    <thead>
                      {/* HEADER 1 */}
                      <tr>
                        <th rowSpan={2} style={{ width: "70px" }}>
                          JP
                        </th>
                        <th rowSpan={2} style={{ width: "160px" }}>
                          Waktu
                        </th>

                        {levels.map((lvl, i) => (
                          <th
                            key={i}
                            colSpan={lvl.data_class.length}
                            style={{
                              whiteSpace: "nowrap",
                            }}
                          >
                            Kelas {lvl.classes_name}
                          </th>
                        ))}
                      </tr>

                      {/* HEADER 2 */}
                      <tr>
                        {levels.map((lvl) =>
                          lvl.data_class.map((cls, i) => (
                            <th
                              key={i}
                              style={{
                                whiteSpace: "nowrap",
                                wordBreak: "break-word",
                              }}
                            >
                              {cls.classrooms_name}
                            </th>
                          )),
                        )}
                      </tr>
                    </thead>

                    <tbody>
                      {map(list.details, (detail, i) => (
                        <tr key={i} style={{ textAlign: "center" }}>
                          <td style={{ width: "70px" }}>{detail.jp}</td>
                          <td style={{ width: "160px" }}>{detail.hour}</td>

                          {headerLevels.map((headerLvl) =>
                            headerLvl.data_class.map((headerCls) => {
                              // cari data yang sesuai
                              const findLevel = detail.levels.find(
                                (lvl) =>
                                  lvl.classes_id === headerLvl.classes_id,
                              );

                              const findClass =
                                findLevel &&
                                findLevel.data_class.find(
                                  (c) =>
                                    c.classrooms_id === headerCls.classrooms_id,
                                );

                              return (
                                <td
                                  key={headerCls.classrooms_id}
                                  style={{
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {findClass ? findClass.teacher_code : "-"}
                                </td>
                              );
                            }),
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
}
RekapJadwal.propTypes = {
  handleListClassData: PropTypes.func,
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
RekapJadwal.defaultProps = {
  handleListClassData: noop,
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
